/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ModifyJobProofLinkRequest model module.
 * @module model/ModifyJobProofLinkRequest
 * @version V1
 */
class ModifyJobProofLinkRequest {
    /**
     * Constructs a new <code>ModifyJobProofLinkRequest</code>.
     * @alias module:model/ModifyJobProofLinkRequest
     * @param jobId {Number} 
     */
    constructor(jobId) { 
        
        ModifyJobProofLinkRequest.initialize(this, jobId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, jobId) { 
        obj['jobId'] = jobId;
    }

    /**
     * Constructs a <code>ModifyJobProofLinkRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ModifyJobProofLinkRequest} obj Optional instance to populate.
     * @return {module:model/ModifyJobProofLinkRequest} The populated <code>ModifyJobProofLinkRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ModifyJobProofLinkRequest();

            if (data.hasOwnProperty('jobId')) {
                obj['jobId'] = ApiClient.convertToType(data['jobId'], 'Number');
            }
            if (data.hasOwnProperty('update')) {
                obj['update'] = ApiClient.convertToType(data['update'], ['Number']);
            }
            if (data.hasOwnProperty('delete')) {
                obj['delete'] = ApiClient.convertToType(data['delete'], ['Number']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ModifyJobProofLinkRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ModifyJobProofLinkRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ModifyJobProofLinkRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is an array
        if (!Array.isArray(data['update'])) {
            throw new Error("Expected the field `update` to be an array in the JSON data but got " + data['update']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['delete'])) {
            throw new Error("Expected the field `delete` to be an array in the JSON data but got " + data['delete']);
        }

        return true;
    }


}

ModifyJobProofLinkRequest.RequiredProperties = ["jobId"];

/**
 * @member {Number} jobId
 */
ModifyJobProofLinkRequest.prototype['jobId'] = undefined;

/**
 * @member {Array.<Number>} update
 */
ModifyJobProofLinkRequest.prototype['update'] = undefined;

/**
 * @member {Array.<Number>} delete
 */
ModifyJobProofLinkRequest.prototype['delete'] = undefined;






export default ModifyJobProofLinkRequest;

